export default __webpack_public_path__ + "static/media/mautoma.531c142d.svg";